import * as React from 'react';

const EmptyAgenda = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={116} height={116} fill="none">
    <path
      fill="#F9F9F9"
      d="M113.329 22.318a35.895 35.895 0 0 1 2.669 13.922v43.5a35.906 35.906 0 0 1-36.247 36.247H7.266a6.843 6.843 0 0 1-5.26-1.993 6.85 6.85 0 0 1-1.993-5.26V36.249A35.906 35.906 0 0 1 36.26.002H79.75a35.906 35.906 0 0 1 33.578 22.316Z"
    />
    <mask
      id="a"
      width={116}
      height={116}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}>
      <path
        fill="#F9F9F9"
        d="M113.329 22.318a35.895 35.895 0 0 1 2.669 13.922v43.5a35.906 35.906 0 0 1-36.247 36.247H7.266a6.843 6.843 0 0 1-5.26-1.993 6.85 6.85 0 0 1-1.993-5.26V36.249A35.906 35.906 0 0 1 36.26.002H79.75a35.906 35.906 0 0 1 33.578 22.316Z"
      />
    </mask>
    <g mask="url(#a)">
      <rect
        width={104}
        height={23}
        x={24.5}
        y={14.5}
        stroke="#E2E2E2"
        rx={4.5}
      />
      <rect width={3} height={12} x={23} y={20} fill="#11D200" rx={1.5} />
      <rect
        width={2}
        height={16}
        x={49}
        y={22}
        fill="silver"
        rx={1}
        transform="rotate(90 49 22)"
      />
      <rect
        width={2}
        height={30}
        x={88}
        y={22}
        fill="silver"
        rx={1}
        transform="rotate(90 88 22)"
      />
      <rect
        width={2}
        height={16}
        x={49}
        y={28}
        fill="silver"
        rx={1}
        transform="rotate(90 49 28)"
      />
      <rect
        width={2}
        height={33}
        x={91}
        y={28}
        fill="silver"
        rx={1}
        transform="rotate(90 91 28)"
      />
      <rect
        width={104}
        height={23}
        x={24.5}
        y={95.5}
        stroke="#E2E2E2"
        rx={4.5}
      />
      <rect width={3} height={12} x={23} y={101} fill="#11D200" rx={1.5} />
      <rect
        width={2}
        height={16}
        x={49}
        y={103}
        fill="silver"
        rx={1}
        transform="rotate(90 49 103)"
      />
      <rect
        width={2}
        height={30}
        x={88}
        y={103}
        fill="silver"
        rx={1}
        transform="rotate(90 88 103)"
      />
      <rect
        width={2}
        height={16}
        x={49}
        y={109}
        fill="silver"
        rx={1}
        transform="rotate(90 49 109)"
      />
      <rect
        width={2}
        height={33}
        x={91}
        y={109}
        fill="silver"
        rx={1}
        transform="rotate(90 91 109)"
      />
      <rect
        width={104}
        height={23}
        x={24.5}
        y={41.5}
        stroke="#E2E2E2"
        rx={4.5}
      />
      <rect width={3} height={12} x={23} y={47} fill="#2961FA" rx={1.5} />
      <rect
        width={2}
        height={16}
        x={49}
        y={49}
        fill="silver"
        rx={1}
        transform="rotate(90 49 49)"
      />
      <rect
        width={2}
        height={30}
        x={88}
        y={49}
        fill="silver"
        rx={1}
        transform="rotate(90 88 49)"
      />
      <rect
        width={2}
        height={16}
        x={49}
        y={55}
        fill="silver"
        rx={1}
        transform="rotate(90 49 55)"
      />
      <rect
        width={2}
        height={33}
        x={91}
        y={55}
        fill="silver"
        rx={1}
        transform="rotate(90 91 55)"
      />
      <rect
        width={104}
        height={23}
        x={24.5}
        y={68.5}
        stroke="#E2E2E2"
        rx={4.5}
      />
      <rect width={3} height={12} x={23} y={74} fill="#F6B408" rx={1.5} />
      <rect
        width={2}
        height={16}
        x={49}
        y={76}
        fill="silver"
        rx={1}
        transform="rotate(90 49 76)"
      />
      <rect
        width={2}
        height={30}
        x={88}
        y={76}
        fill="silver"
        rx={1}
        transform="rotate(90 88 76)"
      />
      <rect
        width={2}
        height={16}
        x={49}
        y={82}
        fill="silver"
        rx={1}
        transform="rotate(90 49 82)"
      />
      <rect
        width={2}
        height={33}
        x={91}
        y={82}
        fill="silver"
        rx={1}
        transform="rotate(90 91 82)"
      />
    </g>
  </svg>
);
export default EmptyAgenda;
